const basePath = 'ql_api/qualified_lead/v1.0';
const basePathNewVersion = '/api/listing/portal/saved-search/v1';
const basePathAgencyNewVersion = '/api/agency/portal/agent-request/v1';

export const SAVED_SEARCH = `${basePath}`;

export const CONNECTION_TYPE = (id: number | string) =>
  `${basePath}/publish/${id}/connectionType`;

export const LADDER = (id: number | string) =>
  `${basePath}/publish/${id}/ladder`;

export const PUBLISH = `${basePath}/publish`;

export const DELETE_SAVE_SEARCH = (id: number | string | undefined) =>
  `${basePath}/publish/${id}`;

export const EDIT_SAVE_SEARCH = DELETE_SAVE_SEARCH;

//new apis
export const PUBLISH_NEW_VERSION = `${basePathNewVersion}/create`;
export const SAVED_SEARCH_NEW_VERSION = `${basePathNewVersion}/search`;
export const PUBLISH_AGENCY_NEW_VERSION = `${basePathAgencyNewVersion}/create`;

export const UPDATE_NOTIFICATION = (id: number | string | undefined) =>
  `${basePathNewVersion}/update-notification/${id}`;

export const DELETE_SAVE_SEARCH_NEW_VERSION = (id: number | string | undefined) =>
  `${basePathNewVersion}/delete/${id}`;
